// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3voaF","disabled":"FileBtn_disabled__3FapR","warn":"FileBtn_warn__252UE","fade":"FileBtn_fade__2pp7Q"};